// extracted by mini-css-extract-plugin
export default {"zoomModal":"h2-z"};